import React, { Fragment } from 'react'

const clickToCall = <span className="italics">(Click phone icon to call)</span>

export const AreYouVet = () => (
  <Fragment>
    <div className="normal">
      Are you a Veteran?&nbsp;<span className="italics">(Select Yes or No)</span>
    </div>
  </Fragment>
)

export const Benefits = () => (
  <Fragment>
    <div className="normal">
      Do you have VA Healthcare Benefits?&nbsp;<span className="italics">(Select Yes or No)</span>
    </div>
  </Fragment>
)

export const Distance = () => (
  <Fragment>
    <div className="normal">
      My drive time to the VA is...&nbsp;<span className="italics">(Select One)</span>
    </div>
  </Fragment>
)

export const Qualify = () => (
  <Fragment>
    <div className="normal">
      Do you qualify for any of these?&nbsp;<span className="italics">(Select One)</span>
    </div>
  </Fragment>
)

export const ReasonFor = () => (
  <Fragment>
    <div className="normal">
      Reason for Appointment...&nbsp;<span className="italics">(Select One)</span>
    </div>
  </Fragment>
)

export const Schedule = () => (
  <Fragment>
    <div className="normal">
      Would you like to schedule with JeffVet?&nbsp;<span className="italics">(Select One)</span>
    </div>
  </Fragment>
)

export const Tried = () => (
  <Fragment>
    <div className="normal">
      Have you tried to get an appointment with the VA?&nbsp;<span className="italics">(Select One)</span>
    </div>
  </Fragment>
)

export const Visit = () => (
  <Fragment>
    <div className="normal">
      For this visit would you like to use...&nbsp;<span className="italics">(Select all that apply)</span>
    </div>
  </Fragment>
)

export const WaitTime = () => (
  <Fragment>
    <div className="normal">
      What is your wait time?&nbsp;<span className="italics">(Select One)</span>
    </div>
  </Fragment>
)

export const CallNow = () => (
  <div className="normal">
    If you live in the greater Philadelphia area call JeffNow.&nbsp;{clickToCall}
  </div>
)

export const KnowMore = () => (
  <div className="normal">
    To know more Call JeffVet.&nbsp;{clickToCall}
  </div>
)

export const ThankYou = () => (
  <div className="normal">
    Thank You!
  </div>
)

export const Authorized = () => (
  <div className="normal">
    Do you have authorization from the VA to schedule a non-VA appointment?&nbsp;<span className="italics">(Select One)</span>
  </div>
)

export const CallVa = () => (
  <div className="normal">
    You might need more information.
  </div>
)

export const NoQualifyVa = () => (
  <div className="normal">
    Looks like you don&#39;t qualify for JeffVet.
  </div>

)
